module.exports = __webpack_public_path__ + "img/room3.ce112ff9.png";